import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';


@Pipe({
  name: 'difftime'
})
export class DiffTimePipe implements PipeTransform {

  transform(value: string, args: any): any {
    const end: any = dayjs(value);
    const today: any = new Date();
    const diffTime = new Date(Math.abs(end - today));
    return diffTime.getHours();
  }

}
